import api from './api';

/**
 * Creates a new change order
 * @param {Object} changeOrderData - The change order data to create
 * @returns {Promise} API response with created change order
 */
export const createChangeOrder = async (changeOrderData) => {
  try {
    const response = await api.post('/change_orders', changeOrderData);
    return response;
  } catch (error) {
    console.error('Error creating change order:', error);
    throw error;
  }
};

/**
 * Retrieves all change orders for a specific project
 * @param {string} projectId - MongoDB ObjectId of the project
 * @returns {Promise} API response with array of change orders
 */
export const getChangeOrdersForProject = async (projectId) => {
  try {
    const response = await api.get(`/change_orders/project/${projectId}`);
    return response; // Interceptor already returns response.data
  } catch (error) {
    console.error('Error fetching change orders:', error);
    throw error;
  }
};

/**
 * Retrieves a single change order by ID
 * @param {string} changeOrderId - MongoDB ObjectId of the change order
 * @returns {Promise} API response with change order details
 */
export const getChangeOrder = async (changeOrderId) => {
  try {
    const response = await api.get(`/change_orders/${changeOrderId}`);
    return response;
  } catch (error) {
    console.error('Error fetching change order:', error);
    throw error;
  }
};

/**
 * Updates a change order (typically status)
 * @param {string} changeOrderId - MongoDB ObjectId of the change order
 * @param {Object} updateData - Data to update (e.g., {status: 'Signed'})
 * @returns {Promise} API response with updated change order
 */
export const updateChangeOrder = async (changeOrderId, updateData) => {
  try {
    const response = await api.put(`/change_orders/${changeOrderId}`, updateData);
    return response;
  } catch (error) {
    console.error('Error updating change order:', error);
    throw error;
  }
};

/**
 * Deletes a change order
 * @param {string} changeOrderId - MongoDB ObjectId of the change order
 * @returns {Promise} API response
 */
export const deleteChangeOrder = async (changeOrderId) => {
  try {
    const response = await api.delete(`/change_orders/${changeOrderId}`);
    return response;
  } catch (error) {
    console.error('Error deleting change order:', error);
    throw error;
  }
};
